import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        dialogData: null //弹框数据
    },
    mutations: {
        setDialogData(state, data) {
			state.dialogData = data
		}
    },
    actions: {
        setDialogDataAsync({ commit, state }, data) {
			commit('setDialogData', data)
		}
    }
})
